export default __webpack_public_path__ + "static/media/icon_time_gray.4cdeb4ec.svg";